module.exports = __webpack_public_path__ + "img/photo.3551008d.png";